import { Box } from 'grommet'
import styled from 'styled-components'

export const RetailersDashContainerStyle = styled(Box)`	
  text-align: start;	
`